/* eslint-disable sort-keys */
import { useDecodedToken } from 'mf_core/auth';
import { useApiPostQuery } from 'mf_core/query';
import { useBillingHeaderProvider } from 'mf_core/provider';

export function usePNAforWarehouse(
  sku: string,
  skuType?: string,
  vendorCode?: string,
  licenseSelectorVendorSubrange?: string,

  brazilReqProps?: any
) {
  const decodedToken = useDecodedToken();
  const siteCode = decodedToken?.siteCode;
  const { billingHeader } = useBillingHeaderProvider();

  return useApiPostQuery<PNAResponse>(
    `/pricing-and-availability/v1/pnas?pnaFilters=includeAvailability=true,includePricing=${
      siteCode?.toLowerCase() === 'br'
    },includeProductAttributes=true,includeDiscounts=false`,
    {
      cnpjNumber: brazilReqProps?.cnpjNumber ?? billingHeader?.cnpjNumber,
      extendedSpecs: brazilReqProps?.extendedSpecs,
      hasIE: brazilReqProps?.hasIE ?? billingHeader?.hasIE,
      item: [
        {
          ingramPartNumber: sku,
          licenseSelectorVendorSubrange: licenseSelectorVendorSubrange,
          IsBundleItem: brazilReqProps?.isBundleItem,
          skuType: skuType,
          bundleComponents: brazilReqProps?.bundleComponents,
          vendorCode: vendorCode,
        },
      ],
      shipToProvince:
        brazilReqProps?.shipToProvince ?? billingHeader?.shipToProvince,
      shipToUF: brazilReqProps?.shipToUF ?? billingHeader?.shipToUF,
    },
    undefined,
    undefined,
    { 'IM-MicroFrontendID': 'cep_app_availability' }
  );
}

export type PnaRequest = {
  item: {
    bundleComponents?: BundleComponents[];
    ingramPartNumber: string;
    isBundleItem?: boolean;
    licenseSelectorVendorSubrange: string;
  };
};

type PNAResponse = [
  {
    productAttributes: Properties[];
    warehouseColumn: ColumnFlag[];
    warehouseList: Attribute[];
  }
];

export type BundleComponents = {
  ingramPartNumber?: string;
  kitType?: string;
  quantity?: string;
  vendorCode?: string;
};

type Properties = {
  reserveInventoryFlag: string;
  totalVisibleReserveQuantity: number;
};

type Attribute = {
  etaDate: string;
  leadTimeEta: string;
  onOrderQuantity: number;
  taxFields?: TaxFields[];
  totalAvailableQuantity: number;
  warehouseAvailableQuantity: number;
  warehouseDescription: string;
};

type ColumnFlag = {
  locationCodeColumn: boolean;
  locationColumn: boolean;
  stockColumn: boolean;
  tatColumn: boolean;
};

type TaxFields = {
  unitPriceWithTax: number;
};
